import type { Schemas } from "polaris-enhance"

import stores from "@/stores"

import SchemaFormPannel from "./content/SchemaFormPannel"
export function showSchemaFormModal<T = any>(props: {
  title: string
  onConfirm: (value: T) => Promise<boolean | void>
  schemas: Schemas
  defaultValues: T
  confirmText?: string
}) {
  stores.CommonStore.setTemporarySchemas(props.schemas)
  stores.CommonStore.setTemporarySchemaForm(props.defaultValues)
  stores.CommonStore.setConfirmModalConfig({
    title: props.title,
    message: <SchemaFormPannel />,
    onConfirm: async () => {
      return await props.onConfirm(stores.CommonStore.temporarySchemaForm)
    },
    extraPrimaryAction: {
      content: props.confirmText || t("Confirm"),
    },
  })
}
